import React from 'react';
import { props } from 'tcomb-react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import Product from '../domain/Product';
import take from 'lodash/array/take';
import Deal from './Deal';
import format_discount from '../util/formatDiscount';
import format_timeago from '../util/formatTimeAgo';
import percentage from '../util/percentage';

@props({
  locale: Locale,
  product: Product
})
export default class Lasts extends React.Component {

  doShow() {
    return this.props.product.runtime.lasts.length > 1;
  }

  getPrice(last) {
    return this.props.product.format_amount(this.props.locale, last.price);
  }

  getDiscount(last) {
    const product = this.props.product;
    return format_discount(this.props.locale, percentage(product.list_price, last.price));
  }

  getSaving(last) {
    const product = this.props.product;
    return product.format_amount(this.props.locale, product.list_price - last.price);
  }

  getDelta(last) {
    // il delta non deve essere visibile per il primo last deal
    /*if (index === 0) {
      return null;
    }*/
    return format_timeago(this.props.locale, last.delta);
  }

  getDeals() {
    return take(this.props.product.runtime.lasts, 3).map((last, index)=>{
      return (
        <span key={'span' + index}>
          <Deal
            key={index}
            locale={this.props.locale}
            price={this.getPrice(last)}
            discount={this.getDiscount(last)}
            saving={this.getSaving(last)}
            delta={this.getDelta(last, index)} />
          <div className='divider'></div>
         </span>
      );
    });
  }

  render() {
    if (!this.doShow()) {
      return null;
    }

    return (
      <div>
        <div id="last_deals" className="box dark small-hide">
          <div className="title">
            <h2>
              <span>
                {get_bundle(this.props.locale).product.last_deals}
              </span>
            </h2>
          </div>
          {this.getDeals()}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Lasts.js
 **/